import { FC } from 'react';

import {
  Reservation,
  Vote,
  // Payment
} from './components';

export const SmartGamerTab: FC = () => {
  return (
    <>
      {/*<Payment />*/}
      <Reservation />
      <Vote />
    </>
  );
};
